import {Dropdown} from 'primereact/dropdown';
import React, {useEffect, useState} from 'react';
import {useGetProductTemplateForeignKeys} from "api/api-hooks/product-templates-hooks";


export interface IForeignKey {
    value: IForeignKeyValue;//change from any
    editable: boolean;
    foreignTemplateKey: string;
    changeHandler: any;
}

export interface IForeignKeyValue {
    objectId: string;
    represantationString: string;
    template: string;
}

interface IOptions {
    label: string;
    value: IForeignKeyValue | null;
}

export default function ForeignKey(props: IForeignKey) {
    const {
        data,
        isError,
        isLoading
    } = useGetProductTemplateForeignKeys(props.foreignTemplateKey, {staleTime: 0,enabled:props.editable});

    const [options, setOptions] = useState<Array<IOptions>>([])

    useEffect(() => {
        if (data) {
            setOptions([{
                label: 'Unselected',
                value: null
            }, ...data.map((ob: any) => {
                return {label: ob.represantationString, value: ob}
            })])
        }
    }, [data])

    const valueChangeHandler = (e: any) => {
        props.changeHandler(e.value);
    }

    const displayValue = props.value?.represantationString ?? 'Not Selected';

    if (props.editable) {
        return <>
            {isLoading &&
                <>Loading...</>
            }

            {isError &&
                <>Error</>
            }

            {!isLoading && !isError &&
                <Dropdown style={{width: '100%', textAlign: 'left'}}
                          value={displayValue}
                          options={options}
                          placeholder={displayValue}
                          onChange={(e) => valueChangeHandler(e)}
                          required
                          dataKey='1'

                />
            }
        </>
    } else {
        return <>
            {
                props?.value?.represantationString ? (
                    <div className="p-inputtext" style={{border: '0px transparent', backgroundColor: 'transparent', whiteSpace: "nowrap"}}>
                        {displayValue}
                    </div>
                ) : (
                    "-"
                )
            }
        </>
    }
}